import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import TableDetails from "Components/Common/TableDetails";
import PagesWrapper from "Components/Common/Pages/PagesWrapper";
import PosSidebar from "Components/Common/PosSidebar";
import VendorAPI from "api/posapi/vendor";
import AppWrapper from "Components/Routes/AppWrapper";
import Button from "Components/Common/Button";

function VendorDetails() {
  let params = useParams();
  const [loading, setLoading] = useState(true);
  const [dataToShow, setDataToShow] = useState([]);
  useEffect(() => {
    setLoading(true);
    VendorAPI.viewVendorAPI(params)
      .then((response) => {
        setDataToShow(response.data.vendor);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/vendors");
  };

  return (
    <>
      <AppWrapper sideBar={<PosSidebar />}>
        <PagesWrapper>
          <div className="flex justify-between my-4">
            <div className="flex items-center text-24 font-semibold">
              Vendor Detail
            </div>
            <div className="w-[8%]">
              <Button
                className="w-full bg-white text-blue border-blue border hover:bg-blue hover:text-white"
                onClick={handleBack}
              >
                Back
              </Button>
            </div>
          </div>
          <div className="w-1/2">
            <TableDetails data={dataToShow} loading={loading} header={false} />
          </div>
        </PagesWrapper>
      </AppWrapper>
    </>
  );
}

export default VendorDetails;
